import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button as AntdButton, Flex, Form, InputNumber, message, Button, Space, } from 'antd';
import { LeftPanel, LeftPanelCard, LeftPanelCardBody, LeftPanelCardFooter, LeftPanelCardHead, LeftPanelContainer, } from '../../../editor.style';
import { useEffect, useState } from 'react';
import Icon from '../../../../../components/common/Icon';
import { _updateFloorData } from '../../../../../shared/httpservice/apis';
import { useDispatch } from 'react-redux';
import { getFloorAction } from '../../../../../store/floorSlice';
const initialValues = {
    zoom: undefined,
    pitch: undefined,
    bearing: undefined,
    bounds: undefined,
    center: undefined,
};
const ViewPortFormPanel = ({ data, siteId, isOpen, onBack }) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [editData, setEditData] = useState(initialValues);
    const [container, setContainer] = useState(null);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (data?.viewport) {
            form.setFieldsValue({
                ...initialValues,
                ...data?.viewport,
            });
            setEditData(data);
        }
        else {
            form.setFieldsValue(initialValues);
            setEditData(initialValues);
        }
    }, [data]);
    return (_jsx(LeftPanel, { isOpen: isOpen, style: {
            width: '340px',
        }, children: _jsx(LeftPanelContainer, { children: _jsxs(LeftPanelCard, { children: [_jsx(LeftPanelCardHead, { children: _jsxs(Flex, { align: "center", children: [_jsx(AntdButton, { style: { marginLeft: '-8px' }, color: "default", variant: "text", icon: _jsx(Icon, { icon: "arrow-left", size: 18 }), onClick: () => {
                                        onBack();
                                    } }), _jsxs("h3", { children: ["Edit Viewport - ", data?.shortName] })] }) }), _jsx(LeftPanelCardBody, { style: { padding: '0 16px 16px' }, ref: setContainer, children: _jsxs(Form, { initialValues: editData || initialValues, form: form, layout: "vertical", onFinish: async (values) => {
                                try {
                                    setLoading(true);
                                    const formattedValues = {
                                        viewport: {
                                            zoom: values.zoom ?? null,
                                            pitch: values.pitch ?? null,
                                            bearing: values.bearing ?? null,
                                            bounds: values?.bounds?.length > 0 &&
                                                values?.bounds?.every((it) => it !== undefined && it !== null)
                                                ? values.bounds
                                                : null,
                                            center: values?.center?.length > 0 &&
                                                values?.center?.every((it) => it !== undefined && it !== null)
                                                ? values.center
                                                : null,
                                        },
                                    };
                                    const { floorId, buildingId } = data;
                                    _updateFloorData(siteId, floorId, formattedValues)
                                        .then((res) => {
                                        if (res?.status === 200) {
                                            message.success('Floor viewport updated successfully');
                                            dispatch(getFloorAction({
                                                siteId,
                                                data: { buildingId: buildingId, pageSize: 50 },
                                                noLoading: true,
                                            }));
                                            onBack();
                                        }
                                        else {
                                            message.error('Floor viewport update failed');
                                        }
                                    })
                                        .finally(() => {
                                        setLoading(false);
                                    });
                                }
                                catch (e) {
                                    message.error('Some error occured');
                                    setLoading(false);
                                }
                            }, children: [_jsx(Form.Item, { label: "Zoom", name: "zoom", rules: [{ required: false, message: 'Zoom is required' }], children: _jsx(InputNumber, { style: { width: '100%' } }) }), _jsx(Form.Item, { label: "Pitch", name: "pitch", rules: [{ required: false, message: 'Pitch is required' }], children: _jsx(InputNumber, { style: { width: '100%' } }) }), _jsx(Form.Item, { label: "Bearing", name: "bearing", rules: [{ required: false, message: 'Bearing is required' }], children: _jsx(InputNumber, { style: { width: '100%' } }) }), _jsx(Form.Item, { label: "Bounds", name: 'bounds_parent', dependencies: ['bounds'], validateTrigger: "onChange", rules: [
                                        {
                                            validator: (_, value) => {
                                                const formValue = form.getFieldValue('bounds');
                                                const data = (formValue || []).filter((it) => it !== undefined && it !== null);
                                                if (!formValue)
                                                    return Promise.resolve();
                                                if (data?.length === 0)
                                                    return Promise.resolve();
                                                if (data.length === 4)
                                                    return Promise.resolve();
                                                return Promise.reject(new Error('All four values are required'));
                                            },
                                        },
                                    ], children: _jsxs(Space.Compact, { children: [_jsx(Form.Item, { dependencies: ['bounds_parent'], name: ['bounds', 0], noStyle: true, children: _jsx(InputNumber, { placeholder: "X1", style: { width: '24%' } }) }), _jsx(Form.Item, { dependencies: ['bounds_parent'], name: ['bounds', 1], noStyle: true, children: _jsx(InputNumber, { placeholder: "Y1", style: { width: '24%' } }) }), _jsx(Form.Item, { dependencies: ['bounds_parent'], name: ['bounds', 2], noStyle: true, children: _jsx(InputNumber, { placeholder: "X2", style: { width: '24%' } }) }), _jsx(Form.Item, { dependencies: ['bounds_parent'], name: ['bounds', 3], noStyle: true, children: _jsx(InputNumber, { placeholder: "Y2", style: { width: '24%' } }) })] }) }), _jsx(Form.Item, { label: "Center", name: 'center_parent', dependencies: ['center'], validateTrigger: "onChange", rules: [
                                        {
                                            validator: (_, value) => {
                                                const formValue = form.getFieldValue('center');
                                                const data = (formValue || []).filter((it) => it !== undefined && it !== null);
                                                if (!formValue)
                                                    return Promise.resolve();
                                                if (data?.length === 0)
                                                    return Promise.resolve();
                                                if (data.length === 2)
                                                    return Promise.resolve();
                                                return Promise.reject(new Error('Both values are required'));
                                            },
                                        },
                                    ], children: _jsxs(Space.Compact, { children: [_jsx(Form.Item, { dependencies: ['center_parent'], name: ['center', 0], noStyle: true, children: _jsx(InputNumber, { placeholder: "X", style: { width: '48%' } }) }), _jsx(Form.Item, { dependencies: ['center_parent'], name: ['center', 1], noStyle: true, children: _jsx(InputNumber, { placeholder: "Y", style: { width: '48%' } }) })] }) })] }) }), _jsxs(LeftPanelCardFooter, { children: [_jsx(Button, { disabled: loading, onClick: () => {
                                    onBack();
                                }, color: "danger", variant: "filled", children: 'Cancel' }), _jsx(Button, { loading: loading, onClick: () => {
                                    form.submit();
                                }, color: "primary", variant: "solid", children: "Save" })] })] }) }) }));
};
export default ViewPortFormPanel;
